/**
 * @generated SignedSource<<27cca3500dc5c82b627055f7fc563bea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type newChatMutation$variables = {
  stream_guid?: any | null | undefined;
  topic?: string | null | undefined;
};
export type newChatMutation$data = {
  readonly insert_stream_one: {
    readonly id: string;
  } | null | undefined;
};
export type newChatMutation = {
  response: newChatMutation$data;
  variables: newChatMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stream_guid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topic"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "stream_guid",
            "variableName": "stream_guid"
          },
          {
            "kind": "Variable",
            "name": "topic",
            "variableName": "topic"
          }
        ],
        "kind": "ObjectValue",
        "name": "object"
      }
    ],
    "concreteType": "stream",
    "kind": "LinkedField",
    "name": "insert_stream_one",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "newChatMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "newChatMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "081cc5388a97dbacaaeddc088eb4ddff",
    "id": null,
    "metadata": {},
    "name": "newChatMutation",
    "operationKind": "mutation",
    "text": "mutation newChatMutation(\n  $topic: String\n  $stream_guid: uuid\n) {\n  insert_stream_one(object: {topic: $topic, stream_guid: $stream_guid}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "09b74ac5916691c274a0e5a899378feb";

export default node;
